import * as types from '../mutation-types'

const state = {
  preMenu:'',
  serviceFootprint: '', // 服务卡片访问记录
  activeMenu: 'myapp',  //默认主页为myapp
  giftPackageStatus: ''  //礼包显示状态
}

const getters = {
  getMenu: state => state.activeMenu,
  getServiceFootprint: state => state.serviceFootprint
}


const actions = {
  setServiceFootprint({ commit }, path) {
    commit(types.SET_SERVICE_FOOTPRINT, path)
  },
  setPreMenu({ commit }, menuName) {
    commit(types.SET_PRE_MENU, menuName)
  },
  setMenu ({ commit }, menuName) {
    commit(types.SET_MENU, menuName)
  },
  setGiftPackageStatus ({ commit }, status) {
    commit(types.SET_GIFTPACKAGE_STATUS, status)
  }
}


const mutations = {
  [types.SET_SERVICE_FOOTPRINT] (state, path) {
    state.serviceFootprint = path
  },
  [types.SET_MENU] (state, menuName) {
    state.activeMenu = menuName
  },
  [types.SET_PRE_MENU] (state, menuName) {
    state.preMenu = menuName
  },
  [types.SET_GIFTPACKAGE_STATUS] (state, status) {
    state.giftPackageStatus = status
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./app/store/modules/menu.js